var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "row px-3"
  }, [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Organization',
        to: '/organization'
      }, {
        label: 'Add New'
      }],
      "title": "New Organization"
    }
  }), _c('div', {
    staticClass: "flex-col w-full bg-white shadow-sm rounded-lg px-4 py-4"
  }, [_c('div', {
    staticClass: "w-1/2"
  }, [_c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.updateOrganization.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-gray-700 mb-2",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" Organization Name ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.name,
      expression: "name"
    }],
    class: ['w-full border rounded-md px-4 py-2 text-sm focus:outline-none focus:ring-2', _vm.isNameExist ? 'border border-red-500 bg-red-custom focus:ring-red-500' : 'border-gray-300 '],
    attrs: {
      "id": "name",
      "type": "text",
      "placeholder": "Enter Organization Name"
    },
    domProps: {
      "value": _vm.name
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "mb-3"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-gray-700 mb-2",
    attrs: {
      "for": "legal_name"
    }
  }, [_vm._v(" Legal Name ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.legal_name,
      expression: "legal_name"
    }],
    staticClass: "w-full border border-gray-300 rounded-md px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500",
    attrs: {
      "id": "legal_name",
      "type": "text",
      "placeholder": "Enter Legal Name"
    },
    domProps: {
      "value": _vm.legal_name
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.legal_name = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "mb-3"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-gray-700 mb-2",
    attrs: {
      "for": "accounting_id"
    }
  }, [_vm._v(" Accounting ID ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.accounting_id,
      expression: "accounting_id"
    }],
    staticClass: "w-full border border-gray-300 rounded-md px-4 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500",
    attrs: {
      "id": "accounting_id",
      "type": "text",
      "placeholder": "Enter Accounting ID"
    },
    domProps: {
      "value": _vm.accounting_id
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.accounting_id = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "mb-3"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-gray-700 mb-2",
    attrs: {
      "for": "group"
    }
  }, [_vm._v(" Organization Status ")]), _c('StatusFilterComponent', {
    attrs: {
      "options": _vm.group_option,
      "defaultText": 'Select Organization Type'
    },
    model: {
      value: _vm.group,
      callback: function ($$v) {
        _vm.group = $$v;
      },
      expression: "group"
    }
  })], 1), _c('div', {
    staticClass: "flex items-center space-x-4"
  }, [_c('button', {
    staticClass: "bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium px-5 py-2 rounded-md",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v(" Save ")]), _c('button', {
    staticClass: "border border-gray-300 text-gray-700 text-sm font-medium px-5 py-2 rounded-md hover:bg-gray-50",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function ($event) {
        return _vm.$router.push('/organization');
      }
    }
  }, [_vm._v(" Cancel ")])])])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }